import request from '@/utils/request'
import qs from 'qs'

//const proxyUrl="/communityapi";
const proxyUrl = process.env.Communityapi;
const Community = process.env.Community;
const Jingjiribao = process.env.Jingjiribao;

//达人榜
export const queryUserAll = (data) => {
  return request({
    method: 'post',
    url: Community + '/queryUserAll',
    data: qs.stringify(data),
  })
};

//社区发现列表
export const topicFind = (data) => {
  return request({
    method: 'post',
    url: proxyUrl + '/circle/topicFind/page',
    data: qs.stringify(data),
  })
};

//轮播图
export const FindBanner = (data) => {
  return request({
    method: 'get',
    url: proxyUrl + '/banner/select/page',

  })
};
//推荐圈子
export const hotCircle = (data) => {
  return request({
    method: 'post',
    url: proxyUrl + '/circle/hotCircle',

  })
};

//加入圈子
export const joinCircle = (data) => {
  return request({
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'post',
    url: proxyUrl + '/circleMember/join/circle',
    data: data,

  })
};

//取消加入圈子
export const canceljoinCircle = (data) => {
  return request({
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'post',
    url: proxyUrl + '/circleMember/cancel/circle',
    data: data,

  })
};

//达人榜是否关注
export const isFollow = (data) => {
  return request({
    method: 'post',
    url: proxyUrl + '/circle/deleteFollow',
    data: qs.stringify(data),
  })
};


// 圈子类别
export const selectCategory = (data) => {
  return request({
    method: 'post',
    url: proxyUrl + '/circle/selectCategory',
    data: qs.stringify(data),
  })
};



// WEBPACK FOOTER //
// ./src/utils/api/communityFind.js